// extracted by mini-css-extract-plugin
export default {"zoomModal":"R3-z"};